import { RefObject, useEffect } from "react";
import { useParams } from "react-router-dom";
import { __assertIsNode } from "./utils";

export function outsideClick(outerRef: RefObject<HTMLDivElement> | RefObject<HTMLLIElement>, cb: (val: boolean) => void) {
    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            __assertIsNode(event.target);

            if (outerRef.current && !outerRef.current.contains(event.target) && !isClickOnDatePicker(event.target)) {
                cb(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [outerRef]);
}

function isClickOnDatePicker(target?: EventTarget | null,): boolean {
    const datePickerModal = document.querySelector('.css-1anqmj6-MuiPopper-root-MuiPickersPopper-root');
    if (target) {
        if (target == datePickerModal || datePickerModal?.contains(target as Node)) {
            return true;
        }
    }
    return false;
}

export function useRequiredParams<T extends Record<string, any>>() { // eslint-disable-line @typescript-eslint/no-explicit-any
    const params = useParams<T>();
    return params as T;
}